import {NgModule} from '@angular/core';
import {PrimeNG} from 'primeng/config';

@NgModule()
export class PrimeNGRussianLocaleModule {
  constructor(config: PrimeNG) {
    config.setTranslation({
      startsWith: 'Начинается с',
      contains: 'Содержит',
      notContains: 'Не содержит',
      endsWith: 'Заканчивается на',
      equals: 'Равно',
      notEquals: 'Не равно',
      noFilter: 'Без фильтра',
      lt: 'Меньше чем',
      lte: 'Меньше или равно',
      gt: 'Больше чем',
      gte: 'Больше или равно',
      is: 'Равно',
      isNot: 'Не равно',
      before: 'Раньше',
      after: 'Позже',
      apply: 'Применить',
      matchAll: 'Совпадает со всеми',
      matchAny: 'Совпадает с любым',
      addRule: 'Добавить правило',
      removeRule: 'Удалить правило',
      accept: 'Да',
      reject: 'Нет',
      choose: 'Выбрать',
      upload: 'Загрузить',
      cancel: 'Отменить',
      dayNames: ['Воскресенье', 'Понедельник', 'Вторник', 'Среда', 'Четверг', 'Пятница', 'Суббота'],
      dayNamesShort: ['Вс', 'Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб'],
      dayNamesMin: ['Вс', 'Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб'],
      monthNames: ['Январь', 'Февраль', 'Март', 'Апрель', 'Май', 'Июнь', 'Июль', 'Август', 'Сентябрь', 'Октябрь', 'Ноябрь', 'Декабрь'],
      monthNamesShort: ['Янв', 'Фев', 'Мар', 'Апр', 'Май', 'Июн', 'Июл', 'Авг', 'Сен', 'Окт', 'Ноя', 'Дек'],
      today: 'Сегодня',
      clear: 'Очистить',
      weekHeader: 'Нед',
      firstDayOfWeek: 1
    });
  }
}
